// @flow

export function extractCardBin(cardNumber: string): string {
  const regex = /^(\d{6})/;
  const results = regex.exec(sanitizeCardNumber(cardNumber));
  if (!results  || results.length < 2) {
    throw new Error('Card number is not valid');
  }
  return results[1];
}

export function extractCardLastFour(cardNumber: string): string {
  const regex = /(\d{4})$/;
  const results = regex.exec(sanitizeCardNumber(cardNumber));
  if (!results  || results.length < 2) {
    throw new Error('Card number is not valid');
  }
  return results[1];
}

export function sanitizeCardNumber(cardNumber: string): string {
  return cardNumber.replace(/\D/g, '');
}

export function validateCardNumber(cardNumber: string): boolean {
  const regex = /^\d{16,19}$/;
  return regex.test(sanitizeCardNumber(cardNumber));
}
